import {
  Checkbox,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Text,
} from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

import { InfoIcon } from '@/imports/ui/chakra/feather';

export const AnnouncementCheckbox: React.FC<{}> = () => {
  const { register } = useFormContext();

  return (
    <Checkbox {...register('isAnnouncement')}>
      Announce this Post
      <Popover trigger="hover" placement="top">
        <PopoverTrigger>
          <InfoIcon ml="2" color="gray" />
        </PopoverTrigger>
        <Portal>
          <PopoverContent bg="gray.700" color="white">
            <PopoverArrow bg="gray.700" />
            <PopoverBody>
              <Text textStyle="compact" fontWeight="semibold">
                Announcements are shown at the top of the feed and users are
                notified via email immediately
              </Text>
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>
    </Checkbox>
  );
};
